import { LOGIN } from './paths'

const getPathWithoutQuery = path => (path || '').split('?')[0]

export const getCurrentPathWithQuery = () => {
  const { pathname = '', search = '' } = window.location
  return `${pathname}${search || ''}`
}

export const isSafeNextPath = nextPath => {
  if (typeof nextPath !== 'string') {
    return false
  }

  const sanitizedPath = nextPath.trim()
  if (!sanitizedPath || !sanitizedPath.startsWith('/') || sanitizedPath === '/') {
    return false
  }

  // Reject scheme-relative and absolute URLs.
  if (sanitizedPath.startsWith('//') || sanitizedPath.includes('://')) {
    return false
  }

  const nextPathWithoutQuery = getPathWithoutQuery(sanitizedPath)
  if (nextPathWithoutQuery === LOGIN) {
    return false
  }

  return true
}

export const isSafeLoginPath = path => {
  if (typeof path !== 'string') {
    return false
  }

  const sanitizedPath = path.trim()
  if (!sanitizedPath || !sanitizedPath.startsWith('/')) {
    return false
  }

  const [pathname, search] = sanitizedPath.split('?')
  if (pathname !== LOGIN) {
    return false
  }

  const params = new URLSearchParams(search || '')
  const nextPath = params.get('next')
  return isSafeNextPath(nextPath)
}

export const buildLoginPathWithNext = nextPath => {
  if (isSafeLoginPath(nextPath)) {
    return nextPath
  }

  if (!isSafeNextPath(nextPath)) {
    return LOGIN
  }

  const params = new URLSearchParams({ next: nextPath })
  return `${LOGIN}?${params.toString()}`
}

export const resolvePostLoginPath = (defaultPath = '/search', search = window.location.search) => {
  try {
    const params = new URLSearchParams(search || '')
    const nextPath = params.get('next')

    if (isSafeNextPath(nextPath)) {
      return nextPath
    }
  } catch (error) {
    // Ignore malformed query strings and fall back to the default path.
  }

  return defaultPath
}
